// extracted by mini-css-extract-plugin
module.exports = {"Style":"_2Yw8R1CqfZ5dbU4G6Wwwme"};